// Global constants for the application
export const SUPPORT_EMAIL = "support@atosarawak.com";
